@if (open) {
  <div
    #overlay
    class="fdk-dialog-overlay"
    (click)="onOverlayClick($event)">
    <section
      class="fdk-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-labelledby]="ariaLabel ? null : dialogTitle?.id">
      <ng-content></ng-content>
    </section>
  </div>
}
